import { type ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import useSign from '@/pages/SignLayout.context';
import IcLock from '@/assets/icons/Lock.svg?react';
import styles from './Login.module.scss';

interface LoginGuardShellProps {
  introKey: string;
  titleKey?: string;
  children: ReactNode;
}

const LoginGuardShell = ({
  introKey,
  titleKey = 'sign:login.guard.title',
  children,
}: LoginGuardShellProps) => {
  const { t } = useTranslation(['sign']);
  const { signing } = useSign();

  return (
    <div className={styles.guard}>
      <span className={styles.iconBadge} aria-hidden="true">
        <IcLock className={styles.iconBadgeIcon} />
      </span>
      <h1 className={styles.guardTitle}>{t(titleKey)}</h1>
      <div className={styles.guardIntro}>
        <Trans
          i18nKey={introKey}
          values={{
            startedName:
              signing?.startedBy?.name ||
              t('sign:login.guard.defaultStartedName'),
            docName: signing?.name || t('sign:login.guard.defaultDocName'),
          }}
          components={{ strong: <strong /> }}
        />
      </div>
      {children}
    </div>
  );
};

export default LoginGuardShell;
